export interface QuestionGroupChange {
  visibleCount: number
  questionId: string
}
